export default "__VITE_ASSET__98045324__"